import handleResponse from './common';
import { fetchJsonByUrlEncodedPost } from './execute';
import { getParams, getPassword, getUsername } from '../reducers/analyticsApp';
import convertLoginResponse from '../converters/loginConverter';

export const login = () => (dispatch, getState) => {
  const state = getState();
  const username = getUsername(state);
  const password = getPassword(state);
  return fetchJsonByUrlEncodedPost(
    '/login',
    `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`,
    getParams(state)
  ).then((response) => ({
    ...convertLoginResponse(response),
    clientTokenTime: new Date().valueOf(),
    tenants: response.tenants,
  }));
};

export const updateToken = ({ backendUrl }, query) =>
  fetch(`${backendUrl}/oauth/access_token`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(query),
  })
    .then(handleResponse)
    .then((response) => response.json());
